import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import PeriodRepository from '../../repositories/PeriodRepository';
import PeriodDataRepository from '../../../data/repositories/PeriodDataRepository';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_CURRENT_PERIOD_REQUEST });
    const periodRepository: PeriodRepository = new PeriodDataRepository();
    const periodResponse = yield call(periodRepository.getCurrentPeriod);
    if (!periodResponse) {
      yield put({
        type: Types.GET_CURRENT_PERIOD_FAILURE,
        error: 'No se pudo leer los datos del periodo.'
      });
      return;
    }
    yield put({
      type: Types.GET_CURRENT_PERIOD_SUCCESS,
      period: periodResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_CURRENT_PERIOD_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del estudiante.'
    });
  }
}
